import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    searchMeta: null,
    filters: [],
    subList: [],
    untrackProducts: [],
    totalQuantityTrack: 0,
    totalSalesTrack: 0,
    totalCostTrack: 0,
    totalProfitTrack: 0,
    totalMarginTrack: 0,
    totalQuantityUntrack: 0,
    totalSalesUntrack: 0,
    totalCostUntrack: 0,
    totalProfitUntrack: 0,
    totalMarginUntrack: 0,
    summaryTrack: {
        quantity: 0,
        total_sold: 0,
        total_cost: 0,
        profit: 0,
        total_margin: 0,
    },
    summaryUntrack: {
        quantity: 0,
        total_sold: 0,
        total_cost: 0,
    },
};

const getters = {
    filters: state => state.filters,

    searchMeta: state => state.searchMeta,

    subList: state => state.subList,

    untrackProducts: state => state.untrackProducts,

    totalQuantityTrack: state => state.totalQuantityTrack,

    totalSalesTrack: state => state.totalSalesTrack,

    totalCostTrack: state => state.totalCostTrack,

    totalProfitTrack: state => state.totalProfitTrack,

    totalMarginTrack: state => state.totalMarginTrack,

    totalQuantityUntrack: state => state.totalQuantityUntrack,

    totalSalesUntrack: state => state.totalSalesUntrack,

    totalCostUntrack: state => state.totalCostUntrack,

    totalProfitUntrack: state => state.totalProfitUntrack,

    totalMarginUntrack: state => state.totalMarginUntrack,

    summaryTrack: state => state.summaryTrack,

    summaryUntrack: state => state.summaryUntrack,
};

const mutations = {
    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    setFilters(state, filters) {
        state.filters = filters;
    },

    setSubList(state, data) {
        state.subList.push(data);
    },

    clearSubList(state) {
        state.subList = [];
    },

    setUntrackProducts(state, data) {
        state.untrackProducts.push(data);
    },

    clearUntrackProducts(state) {
        state.untrackProducts = [];
    },

    setTotalQuantityTrack(state, data) {
        state.totalQuantityTrack = data;
    },

    setTotalSalesTrack(state, data) {
        state.totalSalesTrack = data;
    },

    setTotalCostTrack(state, data) {
        state.totalCostTrack = data;
    },

    setTotalProfitTrack(state, data) {
        state.totalProfitTrack = data;
    },

    setTotalMarginTrack(state, data) {
        state.totalMarginTrack = data;
    },

    setTotalQuantityUntrack(state, data) {
        state.totalQuantityUntrack = data;
    },

    setTotalSalesUntrack(state, data) {
        state.totalSalesUntrack = data;
    },

    setTotalCostUntrack(state, data) {
        state.totalCostUntrack = data;
    },

    setTotalProfitUntrack(state, data) {
        state.totalProfitUntrack = data;
    },

    setTotalMarginUntrack(state, data) {
        state.totalMarginUntrack = data;
    },

    setSummaryTrack(state, data) {
        state.summaryTrack = data;
    },

    setSummaryUntrack(state, data) {
        state.summaryUntrack = data;
    },
};

const actions = {
    getSearchMeta({ commit, dispatch }) {
        let route = Laroute.route(
            'franchise.report.non_fuel.profit.search.meta',
        );

        startLoading(dispatch, 'get-profit-meta');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-profit-meta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-profit-meta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },

    async getSubList({ commit, dispatch }, { params, track }) {
        const url = Laroute.route('franchise.report.non_fuel.profit.sub.list');

        startLoading(dispatch, 'fetch-sub-list');

        try {
            const { data } = await axios.post(url, params);
            if (track === 'true') {
                commit('setSubList', data);
            } else {
                commit('setUntrackProducts', data);
            }
            endLoading(dispatch, 'fetch-sub-list');
            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-sub-list');
            throw e;
        }
    },

    async getSummary({ commit, dispatch }, params) {
        const url = Laroute.route('franchise.report.non_fuel.profit.summary');

        startLoading(dispatch, 'fetch-total-quantity-track');
        startLoading(dispatch, 'fetch-total-sales-track');
        startLoading(dispatch, 'fetch-total-cost-track');
        startLoading(dispatch, 'fetch-total-profit-track');
        startLoading(dispatch, 'fetch-total-margin-track');

        startLoading(dispatch, 'fetch-total-quantity-untrack');
        startLoading(dispatch, 'fetch-total-sales-untrack');
        startLoading(dispatch, 'fetch-total-cost-untrack');
        startLoading(dispatch, 'fetch-total-profit-untrack');
        startLoading(dispatch, 'fetch-total-margin-untrack');

        const { data } = await axios.post(url, params);

        return data;
    },

    async getSummaryV2({ commit, dispatch }, params) {
        const track = new URLSearchParams(params).get('track');

        const url = Laroute.route(
            'franchise.report.non_fuel.profit.summary.v2',
        );

        startLoading(dispatch, 'fetch-summary-track');
        startLoading(dispatch, 'fetch-summary-untrack');

        try {
            const { data } = await axios.post(url, params);
            if (track == 'true') {
                commit('setSummaryTrack', data);
                endLoading(dispatch, 'fetch-summary-track');
            } else {
                commit('setSummaryUntrack', data);
                endLoading(dispatch, 'fetch-summary-untrack');
            }
            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-summary-track');
            endLoading(dispatch, 'fetch-summary-untrack');
            throw e;
        }
    },

    getReportType({ commit, dispatch }) {
        let route = Laroute.route(
            'franchise.report.non_fuel.profit.report.type',
        );

        startLoading(dispatch, 'get-report-type');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'get-report-type');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-report-type');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/profit.js